/* eslint-disable no-unused-expressions */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import { setError } from "./error";

import AuthService from "../../services/authService";
import userService from "../../services/userService";

const accessToken = JSON.parse(localStorage.getItem("token"));

export const checkReferral = createAsyncThunk(
    "auth/checkReferral",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.checkReferral({ formData });
            thunkAPI.dispatch(setMessage(response.data.message));
            return response.data;
        } catch (error) {
            const message = error.response.data.message;
            if(message) {
                thunkAPI.dispatch(setMessage(message));    
            }
            const errorValidation = error.response.data.errors;
            if(errorValidation) {
                thunkAPI.dispatch(setError(errorValidation));
            }
            
            return thunkAPI.rejectWithValue();
        }
    }
);

export const register = createAsyncThunk(
    "auth/register",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.register({ formData });
            thunkAPI.dispatch(setMessage(response.data.message));
            return response.data;
        } catch (error) {
            const errorValidation = error.response.data.errors;
            thunkAPI.dispatch(setError(errorValidation));

            return thunkAPI.rejectWithValue();
        }
    }
);

export const checkUsername = createAsyncThunk(
    "auth/checkUsername",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.checkUsername({ formData });
            thunkAPI.dispatch(setMessage(response.data.message));
            return response.data;
        } catch (error) {
            const message = error.response.data.message;
            if(message) {
                thunkAPI.dispatch(setMessage(message));    
            }
            const errorValidation = error.response.data.errors;
            if(errorValidation) {
                thunkAPI.dispatch(setError(errorValidation));
            }

            return thunkAPI.rejectWithValue();
        }
    }
);

export const login = createAsyncThunk(
    "auth/login",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.login({ formData });
            return { token: response.accessToken, isEmailVerified: response.isEmailVerified, isJoiningPackagePurchased: response.joiningPackage };
        } catch (error) {
            const message = error.response.data.message;
            if(message) {
                thunkAPI.dispatch(setMessage(message));    
            }
            const errorValidation = error.response.data.errors;
            if(errorValidation) {
                thunkAPI.dispatch(setError(errorValidation));
            }

            return thunkAPI.rejectWithValue();
        }
    }
);

export const forgotPassword = createAsyncThunk(
    "auth/forgotPassword",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.forgotPassword({ formData });
            thunkAPI.dispatch(setMessage(response.data.message));

            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(
                error.response.data.errors.email[0]
            );
        }
    }
);

export const verifyCode = createAsyncThunk(
    "auth/verifyCode",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.verifyCode({ formData });
            thunkAPI.dispatch(setMessage(response.data.message));

            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const resetPassword = createAsyncThunk(
    "auth/resetPassword",
    async ({ formData }, thunkAPI) => {
        try {
            const response = await AuthService.resetPassword({ formData });
            thunkAPI.dispatch(setMessage(response.data.message));
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const logout = createAsyncThunk(
    "auth/logout", 
    async () => {
        await AuthService.logout();
    }
);

export const getUserDetails = createAsyncThunk(
    "auth/getUserDetails",
    async (arg, { getState, rejectWithValue }) => {
        try {
            const data = await userService.getUser();
            return { user: data.data.user };
        } catch (error) {
            if(error.response.status == 401) {
                localStorage.removeItem("token");
                window.location.replace("/login?q=session");
            }
            // if (error.response && error.response.data.message) {
            //     return rejectWithValue(error.response.data.message);
            // } else {
            //     return rejectWithValue(error.message);
            // }
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    isLoggedIn: accessToken ? true : false,
    token: accessToken ? accessToken : null,
    isJoiningPackagePurchased: 0,
    isEmailVerified: 0,
    user: null,
    isUsername: false,
    username: null,
    isReferral: false,
    referral: null,
    referral_id: null,
    forgot_password_email: null,
    forgot_password_status: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    extraReducers: {
        [checkReferral.fulfilled]: (state, action) => {
            state.isReferral = true;
            state.referral = action.payload.referral;
            state.referral_id = action.payload.referral_id;
        },
        [checkReferral.rejected]: (state, action) => {
            state.isReferral = false;
            state.referral = action.payload.referral;
            state.referral_id = action.payload.referral_id;
        },
        [register.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.token = action.payload.accessToken;
        },
        [register.rejected]: (state, action) => {
            state.isLoggedIn = false;
            state.token = null;
        },
        [checkUsername.fulfilled]: (state, action) => {
            state.isUsername = true;
            state.username = action.payload.username;
        },
        [checkUsername.rejected]: (state, action) => {
            state.isUsername = false;
            state.username = action.payload.username;
        },
        [login.pending]: (state) => {
            state.loading = true;
        },
        [login.fulfilled]: (state, action) => {
            state.loading = false;
            state.isLoggedIn = action.payload.token ? true : false;
            state.token = action.payload.token;
            state.isEmailVerified = action.payload.isEmailVerified;
            state.isJoiningPackagePurchased = action.payload.isJoiningPackagePurchased;
        },
        [login.rejected]: (state, action) => {
            state.loading = false;
            state.isLoggedIn = false;
            // state.token = null;
            state.token = action.payload.token;
            state.isEmailVerified = action.payload.isEmailVerified;
            state.isJoiningPackagePurchased = action.payload.isJoiningPackagePurchased;
        },
        [forgotPassword.pending]: (state) => {
            state.loading = true;
        },
        [forgotPassword.fulfilled]: (state, action) => {
            (state.loading = false),
                (state.forgot_password_email = action.payload.email),
                (state.forgot_password_status = action.payload.status);
        },
        [forgotPassword.rejected]: (state, action) => {
            (state.loading = false), (state.error = action.payload);
        },
        [verifyCode.pending]: (state) => {
            state.loading = true;
        },
        [verifyCode.fulfilled]: (state, action) => {
            (state.loading = false),
                (state.forgot_password_status = action.payload.status);
        },
        [verifyCode.rejected]: (state, action) => {
            state.loading = false;
        },
        [resetPassword.pending]: (state) => {
            state.loading = true;
        },
        [resetPassword.fulfilled]: (state, action) => {
            state.loading = false;
            (state.forgot_password_email = null),
                (state.forgot_password_status = null);
        },
        [resetPassword.rejected]: (state, action) => {
            state.loading = false;
        },
        [getUserDetails.pending]: (state) => {
            state.loading = true;
        },
        [getUserDetails.fulfilled]: (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
        },
        [getUserDetails.rejected]: (state, action) => {
            state.loading = false;
        },
        [logout.fulfilled]: (state, action) => {
            state.isLoggedIn = false;
            state.user = null;
        },
    },
});

const { reducer } = authSlice;
export default reducer;
